/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_SendInputs */

const en_contact_form_send = /** @type {(inputs: Contact_Form_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const pl_contact_form_send = /** @type {(inputs: Contact_Form_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Contact_Form_SendInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_send = /** @type {((inputs?: Contact_Form_SendInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_SendInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_send(inputs)
	return en_contact_form_send(inputs)
});